import { drawingStore } from "../store";

export const subscribeToDrawingStore = (callback: () => void) => {
  const store = drawingStore.reduxStore?.store;
  if (!store) return;

  return store.subscribe(callback);
};
